import { useContext, useEffect } from 'react'
import { ModalContext, useConfigurationContext } from '@nv/contexts'
import PEILogo from '@nv/images/logos/pei/pei-logo'
import { useTranslation } from 'react-i18next'
import { Colon } from '../../../colon/Colon'
import styles from './ContactUsInfo.module.scss'

export const ContactUsInfo = () => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)
  const { contactInfoHelpSupportData } = useConfigurationContext()
  useEffect(() => {
    // TODO: fix this logo issue with config etc.
    setHeaderLabel(<PEILogo />)
    setBtns([{ text: t('buttons.ok'), onClick: onClose, variant: 'secondary' }])
  }, [])

  return (
    <div className={styles['container']}>
      {contactInfoHelpSupportData.contactNumber && (
        <>
          <p>
            {t('contactUs.contactNumber')}
            <Colon />
          </p>
          <p>{contactInfoHelpSupportData.contactNumber}</p>
        </>
      )}
      {contactInfoHelpSupportData.tollFreeContactNumber && (
        <>
          <p className={styles['label']}>
            {t('contactUs.tollFree')}
            <Colon />
          </p>
          <p className={styles['toll-free']}>{contactInfoHelpSupportData.tollFreeContactNumber}</p>
        </>
      )}

      {contactInfoHelpSupportData.email && (
        <>
          <p className={styles['label']}>
            {t('form.labels.email')}
            <Colon />
          </p>
          <p>
            <strong>{contactInfoHelpSupportData.email}</strong>
          </p>
        </>
      )}
      {contactInfoHelpSupportData.mailingAddress && (
        <>
          <p className={styles['label']}>{t('contactUs.mailingAddress')}:</p>
          <strong>
            {contactInfoHelpSupportData.mailingAddress.line1}
            <br />
            {contactInfoHelpSupportData.mailingAddress.line2 && (
              <>
                {contactInfoHelpSupportData.mailingAddress.line2}
                <br />
              </>
            )}
            {contactInfoHelpSupportData.mailingAddress.line3 && (
              <>
                {contactInfoHelpSupportData.mailingAddress.line3}
                <br />
              </>
            )}
          </strong>
        </>
      )}
    </div>
  )
}
